import { IFormData } from '../../components/FormHelper/FormHelper.types';
import { ICourt } from '../../models/ICourt';
import { IFacilities } from '../../types/sports.types';
import instance from './axios';

type SportProps = {
  date?: string;
  sheet?: string;
  court?: string;
};

const ENDPOINTS = {
  SPORT_COACHING: '/sports/coaching',
  SPORTS: '/sports',
  SPORT_CANCEL: '/sports/cancel',
  FACILITIES: '/facilities',
};

const getSport = (props?: SportProps) => {
  return instance.get<ICourt>(ENDPOINTS.SPORTS, {
    params: props,
  });
};

const getFacilities = () => {
  return instance.get<{
    facilities: IFacilities[];
  }>(ENDPOINTS.FACILITIES);
};

const postSport = (data: IFormData) => {
  return instance.post<any>(ENDPOINTS.SPORTS, data);
};

const postSportCoaching = (data: IFormData) => {
  return instance.post<any>(ENDPOINTS.SPORT_COACHING, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

const postCancelSport = (data: IFormData) => {
  return instance.post<any>(ENDPOINTS.SPORT_CANCEL, data);
};

const SportApi = {
  postSportCoaching,
  getSport,
  postSport,
  postCancelSport,
  getFacilities,
};

export default SportApi;
